<template>
  <vs-prompt
      buttons-hidden
      class="large"
      title="تسجيل في مادة دراسية"
      @close="close"
      :active="active"
  >

    <div class="vx-row">
      <div class="vx-col mx-4 w-full mb-4">
        <v-select
            v-model="selectedCourse"
            :options="courses"
            :getOptionLabel="item => `${item.course_id} - ${item.course_name} - ${item.group}`"
            :clearable="false"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-validate="'required'" data-vv-scope="add" name="course"
        >
          <div slot="no-options">عذرا ، لا توجد خيارات مطابقة</div>
        </v-select>
        <span class="text-danger text-sm" v-show="errors.has('add.course')">يجب تحديد المادة الدراسية</span>
      </div>
    </div>
    <vs-divider />
    <div class="flex justify-end">
      <vs-button @click="close" class="mx-5" type="flat">رجوع</vs-button>
      <vs-button @click="submitClicked">حفظ</vs-button>
    </div>

  </vs-prompt>
</template>

<script>
    import termsAPI from '@/api/admin/termsAPI'
    import studentsAPI from '@/api/admin/studentsAPI'

    export default {
        name: 'StudentForm',
        props: {
          active: {
            type: Boolean,
            default: false
          },
        },
        watch: {
            active(val){
                if(!val) return
                this.$validator.reset()
            }
        },
        data () {
            return {
                courses: [],
                selectedCourse: null,
            }
        },
        methods: {
            submitClicked(){
                this.$validator.validateAll().then((result) => {
                    if(result) {
                      const id = this.$route.params.student_id
                      studentsAPI.addCourse(id, this.selectedCourse.course_id, this.selectedCourse.group)
                          .then(response => {
                            if(response.data.message === 'already_registered') {
                              this.$notifyError('هذه المادة مسجله للطالب بالفعل !')
                              return
                            }
                            this.$emit('submit', {...this.selectedCourse})
                            this.close()
                            this.$notifySuccess(response.successMessage)
                          })
                          .catch(response => this.$notifyError(response.statusMessage))
                          .finally(() => this.$closeLoading())
                    }
                })

            },
            close(){
                this.$emit('update:active', false)
            },
        },
      created () {
        termsAPI.currentCourseTerms().then(({data}) => {
          this.courses = data
        })
      }
    }
</script>
